module.exports = __webpack_public_path__ + "fonts/BerninaSans-Regular.6dedcc38.woff";